export default {
  dataInicial: {
    value: '',
    required: true,
    state: null
  },
  diaSemana: {
    value: '',
    required: true,
    state: null
  },
  horaInicial: {
    value: '',
    required: true,
    state: null
  },
  horaFinal: {
    value: '',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/horarioAtendimento/components/add/horarioAtendimentoadd-form.js